// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination-control{display:flex;justify-content:flex-end}.pagination-control ul{margin-bottom:0 !important}.pagination-control .page-item.active .page-link{background-color:#37aba1;border-color:#37aba1}", ""]);
// Exports
module.exports = exports;
